import {createElement} from 'react';
import {CommonLink} from '../components/CommonLink';
import {convertNlToBr} from './convertNlToBr';

// URLマッチング用の正規表現
const URL_REGEX = /(https?:\/\/[\w!?/+\-_~=;.,*&@#$%()'[\]:]+)/;

/**
 * URLが安全なプロトコル(http/https)であるかを検証する
 * javascript:, data:, vbscript: などの危険なプロトコルをブロック
 */
export const isSafeUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    // URLとしてパースできない場合は安全でないとみなす
    return false;
  }
};

export const convertToLink = (text: string, className?: string) => {
  const convertedText = convertNlToBr(text);
  return convertedText.map((item) => {
    if (typeof item !== 'string') {
      return item;
    }

    return item.split(URL_REGEX).map((line, i) => {
      // 正規表現にマッチし、かつ安全なURLの場合のみリンクに変換
      if (URL_REGEX.test(line) && isSafeUrl(line)) {
        return createElement(
          CommonLink,
          {
            key: i,
            target: '_blank',
            href: line,
            className: `text leading text-link-1 pc:hover:opacity-80 pc:hover:ease-in-out pc:hover:duration-300${className ? ` ${className}` : ''}`,
            rel: 'noreferrer',
          },
          line,
        );
      }

      return line;
    });
  });
};
